<template>
  <div>
    <b-card no-body>
      <b-tabs pills card>
        <b-tab :title="$t('Main')">
          <b-form-group label-align="right" :label="$t('Parent service')" label-cols="4" label-cols-xl="4" label-cols-md="4" v-if="isTariffs || isTariffPlan">
            <b-form-input type="text" disabled v-model="telephonyServices.service_data.parent_id"/>
          </b-form-group>
          <b-form-group label-align="right" :label="$t('Full name')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <b-form-input type="text" v-model="serviceName" aria-describedby="inputFeedbackName" :state="validationName"/>
            <b-form-invalid-feedback id="inputFeedbackName">
              {{ $t('Enter title') }}
            </b-form-invalid-feedback>
          </b-form-group>
          <b-form-group label-align="right" :label="$t('Comment')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <b-form-input type="text" v-model="telephonyServices.service_data.comment"/>
          </b-form-group>
          <b-form-group label-align="right" :label="$t('Supplier to invoice')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <b-form-select :options="suppliertList" v-model="selectSupplier"/>
          </b-form-group>
          <b-form-group v-if="isTemplates || isTariffs || isTariffPlan">
            <b-form-checkbox v-model="linkByDefault">{{ $t('Attach by default') }}</b-form-checkbox>
            <b-form-checkbox v-model="multipleLinking">{{ $t('Allow multiple linking') }}</b-form-checkbox>
          </b-form-group>
        </b-tab>
        <b-tab :title="$t('Service parameters')">
          <b-form-group label-align="right" :label="$t('Cost')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <b-form-input type="number" v-model="serviseCost" aria-describedby="inputFeedbackCost" :state="validationCost"/>
            <b-form-invalid-feedback id="inputFeedbackCost">
              {{ $t('Enter cost') }}
            </b-form-invalid-feedback>
          </b-form-group>
          <b-form-group label-align="right" :label="$t('Minimal invoice summ')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <b-form-input type="number" v-model="telephonyServices.telephony_service_data.cost_info.min_charge"/>
          </b-form-group>
          <b-form-group label-align="right" :label="$t('Charge method')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <b-form-select :options="chargeMethodList" v-model="selectChargeMethod"/>
          </b-form-group>
          <b-form-group label-align="right" :label="$t('Charge policy')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <b-form-select :options="policyList" v-model="selectPolicy"/>
          </b-form-group>
          <b-form-group label-align="right" :label="$t('Scheme for schedule')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <b-form-select :options="schemeList" v-model="selectScheme">
              <template slot="first">
                <option :value=0>---</option>
              </template>
            </b-form-select>
          </b-form-group>
          <b-form-group label-align="right" :label="$t('Contract type')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <b-form-select :options="contractList" v-model="selectContract">
              <template slot="first">
                <option :value=0></option>
              </template>
            </b-form-select>
          </b-form-group>
          <b-form-group label-align="right" :label="$t('Free time')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <b-form-input type="number" v-model="telephonyServices.telephony_service_data.cost_info.free_time"/>
          </b-form-group>
          <b-form-group label-align="right" :label="$t('Starting period length')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <b-form-input type="number" v-model="telephonyServices.telephony_service_data.cost_info.first_period_length"/>
          </b-form-group>
          <b-form-group label-align="right" :label="$t('Starting period step')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <b-form-input type="number" v-model="telephonyServices.telephony_service_data.cost_info.first_period_step"/>
          </b-form-group>
          <b-form-group label-align="right" :label="$t('Next period step')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <b-form-input type="number" v-model="telephonyServices.telephony_service_data.cost_info.second_period_step"/>
          </b-form-group>
          <b-form-group label-align="right" :label="$t('Tariffication unit size')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <b-form-input type="number" v-model="telephonyServices.telephony_service_data.cost_info.time_unit_size"/>
          </b-form-group>
          <b-form-group label-align="right" :label="$t('Limit of simulaneous sessions')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <b-form-input type="number" v-model="telephonyServices.periodic_service_data.radius_sessions_limit"/>
          </b-form-group>
          <b-form-group label-align="right" :label="$t('Discount free time')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <b-form-checkbox v-model="telephonyServices.telephony_service_data.cost_info.discount_free_time"/>
          </b-form-group>
        </b-tab>
        <b-tab :title="$t('Price editor')">
          <b-form-group label-align="right" :label="$t('Time range')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <b-button size="sm" variant="success" @click="showAddTimeRange">{{ $t('Add') }}</b-button>
          </b-form-group>
          <b-form-group :label="$t('Direction/zone')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <b-button size="sm" variant="success" @click="showAddTelDirections">{{ $t('Add direction') }}</b-button>
            <b-button size="sm" variant="success" @click="showAddTelZones">{{ $t('Add zone') }}</b-button>
          </b-form-group>

          <b-card style="font-size:14px !important; border-width:0px">
            <b-row>
              <b-col style="border-width: 1px;border-style: solid;max-width:120px;border-color:rgba(0, 0, 0, 0.125);">
                {{ $t('Direction/zone') }}
              </b-col>
              <b-col style="border-width: 1px;border-style: solid;border-color:rgba(0, 0, 0, 0.125);" v-for="item in this.costTimeRange" :key="item.time_range_id">
                <b-row>
                  <b-col cols="7" >
                    {{ item.nameTimeRange }}
                  </b-col>
                  <b-col cols="5" style="padding-left:0px;padding-right:0px;">
                    <b-button size="sm" id="transparent" @click="deleteTimeRange(item)">
                      <b-img :src='deleteImage'/>
                    </b-button>
                  </b-col>
                </b-row>
              </b-col>
              <b-col style="border-width: 1px;border-style: solid;border-color:rgba(0, 0, 0, 0.125);">
              </b-col>
            </b-row>
            <b-row v-for="item in this.costTable" :key="item.tariff_key">
              <b-col style="border-width: 1px;border-style: solid;max-width:120px;border-color:rgba(0, 0, 0, 0.125);">
                {{ item.nameTel }}
              </b-col>
              <b-col style="border-width: 1px;border-style: solid;border-color:rgba(0, 0, 0, 0.125);" v-for="itemd in item.cost_info" :key="itemd.time_range_id">
                <b-form-input v-model="itemd.cost"/>
              </b-col>
              <b-col style="border-width: 1px;border-style: solid;border-color:rgba(0, 0, 0, 0.125);">
                <b-button size="sm" id="transparent" @click="deleteCost(item)">
                  <b-img :src='deleteImage'/>
                </b-button>
              </b-col>
            </b-row>
          </b-card>
        </b-tab>
        <b-tab :title="$t('Tariffication borders')">
          <b-button size="sm" variant="success" @click="showAddTelDirBorder">{{ $t('Add direction') }}</b-button>
          <b-button size="sm" variant="success" @click="showAddTelZonesBorder">{{ $t('Add zone') }}</b-button>
          <b-col class="mt-3"/>
          <b-card>
            <b-row>
              <b-col>
                <h4>{{ $t('Direction/zone') }}</h4>
              </b-col>
              <b-col>
                <h4>{{ $t('Border') }}</h4>
              </b-col>
              <b-col>
                <h4>{{ $t('Coefficient') }}</h4>
              </b-col>
              <b-col>
                <h4>{{ $t('Actions') }}</h4>
              </b-col>
            </b-row>
            <b-row v-for="item in borderRoll" v-bind:key="item.tariff_key">
              <b-col>
                <h4>{{ item.nameTel }}</h4>
              </b-col>
              <b-col>
                <b-form-input type="number" v-model="item.border"/>
              </b-col>
              <b-col>
                <b-form-input type="number" v-model="item.cost_coefficient"/>
              </b-col>
              <b-col>
                <b-button size="sm" id="transparent" @click="deleteBorder(item)">
                  <b-img :src='deleteImage'/>
                </b-button>
              </b-col>
            </b-row>
          </b-card>
        </b-tab>
        <b-tab :title="$t('Prepaid values')">
          <b-button size="sm" variant="success" @click="showAddTelDirPrepaid">{{ $t('Add direction') }}</b-button>
          <b-button size="sm" variant="success" @click="showAddTelZonesPrepaid">{{ $t('Add zone') }}</b-button>
          <b-col class="mt-3"/>

          <b-card>
            <b-row>
              <b-col>
                <h4>{{ $t('Direction/zone') }}</h4>
              </b-col>
              <b-col>
                <h4>{{ $t('Value') }}</h4>
              </b-col>
              <b-col>
                <h4>{{ $t('Actions') }}</h4>
              </b-col>
            </b-row>
            <b-row v-for="item in prepaidRoll" v-bind:key="item.tariff_key">
              <b-col>
                <h4>{{ item.nameTel }}</h4>
              </b-col>
              <b-col>
                <b-form-input type="number" v-model="item.cost_info.prepaid"/>
              </b-col>
              <b-col>
                <b-button size="sm" id="transparent" @click="deletePrepaid(item)">
                  <b-img :src='deleteImage'/>
                </b-button>
              </b-col>
            </b-row>
          </b-card>
        </b-tab>
        <b-tab :title="$t('Fixed cost')">
          <b-button size="sm" variant="success" @click="showAddTelDirFixed">{{ $t('Add direction') }}</b-button>
          <b-button size="sm" variant="success" @click="showAddTelZonesFixed">{{ $t('Add zone') }}</b-button>
          <b-col class="mt-3"/>

          <b-card>
            <b-row>
              <b-col>
                <h4>{{ $t('Direction/zone') }}</h4>
              </b-col>
              <b-col>
                <h4>{{ $t('Value') }}</h4>
              </b-col>
              <b-col>
                <h4>{{ $t('Actions') }}</h4>
              </b-col>
            </b-row>
            <b-row v-for="item in fixedRoll" v-bind:key="item.tariff_key">
              <b-col>
                <h4>{{ item.nameTel }}</h4>
              </b-col>
              <b-col>
                <b-form-input type="number" v-model="item.cost_info.fixed_cost"/>
              </b-col>
              <b-col>
                <b-button size="sm" id="transparent" @click="deleteFixed(item)">
                  <b-img :src='deleteImage'/>
                </b-button>
              </b-col>
            </b-row>
          </b-card>
        </b-tab>
        <b-tab :title="$t('Radius parameters')">
          <b-row>
            <b-col style="margin:5px">
              <b-button variant="success" @click="swohAddRadiusAttr">{{ $t('Add') }}</b-button>
            </b-col>
          </b-row>
          <b-table small striped hover :items="radiusAttrItems" :fields="radiusAttrFields">
            <template v-slot:cell(actions)="row">
              <b-button size="sm" @click.stop="ClickOnEditRadiusAttrButton(row)" id="transparent">
                <b-img :src='editImage'/>
              </b-button>
              <b-button size="sm" @click.stop="deleteRadiusAttr(row)" id="transparent">
                <b-img :src='deleteImage'/>
              </b-button>
            </template>
          </b-table>
        </b-tab>
      </b-tabs>
    </b-card>
    <b-row>
      <b-col>
        <b-button class="mt-3" variant="success" style="float: right; width: 100px" @click="saveTelephonyService">Ok</b-button>
      </b-col>
      <b-col sm="1.5">
        <b-button class="mt-3" variant="secondary" style="float: right; width: 100px" @click="hideModalServices">{{ $t('Cancel') }}</b-button>
      </b-col>
    </b-row>

    <b-modal hide-footer :title="$t('Time range')" ref="modalTimeRange" size="lg">
      <b-table striped hover
      :items="timeRangeList"
      :fields="timeRangeFields"
      selectable
      select-mode="single"
      @row-clicked="rowClickTimeRange">
      </b-table>
      <b-row>
        <b-col>
          <b-button class="mt-3" variant="success" style="float: right; width: 100px" @click="addTimeRange">Ok</b-button>
        </b-col>
        <b-col sm="1.5">
          <b-button class="mt-3" variant="secondary" style="float: right; width: 100px" @click="hideAddTimeRange">{{ $t('Cancel') }}</b-button>
        </b-col>
      </b-row>
    </b-modal>

    <b-modal hide-footer :title="$t('Telephone directions')" ref="modalTelDirections" size="lg">
      <b-table striped hover
      :items="telDirectionsItems"
      :fields="telDirectionsFields"
      selectable
      select-mode="single"
      @row-clicked="rowClickTelDirections">
      </b-table>
      <b-row>
        <b-col>
          <b-button class="mt-3" variant="success" style="float: right; width: 100px" @click="addTelDirections">Ok</b-button>
        </b-col>
        <b-col sm="1.5">
          <b-button class="mt-3" variant="secondary" style="float: right; width: 100px" @click="hideAddTelDirections">{{ $t('Cancel') }}</b-button>
        </b-col>
      </b-row>
    </b-modal>

    <b-modal hide-footer :title="$t('Telephone zones')" ref="modalTelZones" size="lg">
      <b-table striped hover
      :items="telZonesItems"
      :fields="telZonesFields"
      selectable
      select-mode="single"
      @row-clicked="rowClickTelZones">
      </b-table>
      <b-row>
        <b-col>
          <b-button class="mt-3" variant="success" style="float: right; width: 100px" @click="addTelZones">Ok</b-button>
        </b-col>
        <b-col sm="1.5">
          <b-button class="mt-3" variant="secondary" style="float: right; width: 100px" @click="hideAddTelZones">{{ $t('Cancel') }}</b-button>
        </b-col>
      </b-row>
    </b-modal>

    <b-modal hide-footer :title="$t('Radius parameters')" ref="modalRadiusAttr" size="lg">
      <FormRadiusAttributs
      @hideAddRadiusAttr="hideAddRadiusAttr"
      :isEditRadiusAttr="isEditRadiusAttr"
      :rowRadiusAttr="rowRadiusAttr"
      :radiusAttrItems="radiusAttrItems"/>
    </b-modal>
  </div>
</template>

<script>

import moment from 'moment'
import axiosInstance from '@/utils/api.js'
import FormRadiusAttributs from '@/pages/tariffication/servicesAndTariffs/formRadiusAttributs'

export default {
  components: {
    FormRadiusAttributs
  },
  props: {
    isTariffs: null,
    isTemplates: null,
    isEdit: null,
    isTariffPlan: null,
    currentRowService: null,
    currentRowTariffPlans: null
  },
  data () {
    return {
      isBorder: false,
      isFixed: false,
      isPrepaid: false,
      borderRoll: [],
      prepaidRoll: [],
      fixedRoll: [],
      telZonesItems: [],
      telDirectionsItems: [],
      requestTelDir: {
        'offset': 0,
        'count': 100,
        'excepted_dir_ids': []
      },
      rowTimeRange: null,
      rowTelDirections: null,
      rowTelZones: null,
      timeRangeList: [],
      timeRangeFields: [
        {key: 'tr_id', label: 'ID', sortable: true},
        {key: 'name', label: this.$i18n.t('Name'), sortable: true},
        {key: 'range', label: this.$i18n.t('Range'), sortable: true},
        {key: 'priority', label: this.$i18n.t('Priority'), sortable: true}
      ],
      telDirectionsFields: [
        {key: 'dir_id', label: 'ID', sortable: true},
        {key: 'name', label: this.$i18n.t('Name'), sortable: true},
        {key: 'create_date', label: this.$i18n.t('Created on'), sortable: true},
        {key: 'update_date', label: this.$i18n.t('Updated on'), sortable: true},
        {key: 'zones', label: this.$i18n.t('Zone'), sortable: true},
        {key: 'calling_prefix', label: this.$i18n.t('Calling prefix'), sortable: true},
        {key: 'called_prefix', label: this.$i18n.t('Called prefix'), sortable: true}
      ],
      telZonesFields: [
        {key: 'zone_id', label: 'ID', sortable: true},
        {key: 'name', label: this.$i18n.t('Name'), sortable: true},
        {key: 'create_date', label: this.$i18n.t('Created on'), sortable: true},
        {key: 'update_date', label: this.$i18n.t('Updated on'), sortable: true},
        {key: 'supplier_id', label: this.$i18n.t('Supplier id'), sortable: true}
      ],
      costTimeRange: [],
      costTable: [],
      editImage: require('@/assets/img/document_edit.png'),
      deleteImage: require('@/assets/img/document_delete.png'),
      linkByDefault: true,
      multipleLinking: false,
      serviceName: '',
      serviseCost: 0,
      validationName: false,
      validationCost: true,
      selectSupplier: 0,
      suppliertList: [],
      selectContract: 0,
      contractList: [],
      selectPolicy: 0,
      policyList: [],
      selectScheme: 0,
      schemeList: [],
      selectChargeMethod: 1,
      chargeMethodList: [
        {text: this.$i18n.t('At the start of the period'), value: 1},
        {text: this.$i18n.t('At the end of the period'), value: 2},
        {text: this.$i18n.t('Flow method'), value: 3}
      ],
      isEditRadiusAttr: false,
      rowRadiusAttr: null,
      radiusAttr: {
        'set_object_id': 0,
        'set_type': 6,
        'attrs': []
      },
      radiusAttrItems: [],
      radiusAttrFields: [
        {key: 'vendor', label: this.$i18n.t('Vendor'), sortable: true},
        {key: 'code', label: this.$i18n.t('Attribute'), sortable: true},
        {key: 'value', label: this.$i18n.t('Value'), sortable: true},
        {key: 'attrType', label: this.$i18n.t('Type'), sortable: true},
        {key: 'actions', label: this.$i18n.t('Actions'), sortable: true}
      ],
      editTelephonyServices: null,
      telephonyServices: {
        'periodic_service_data': {
          'charge_method': 0,
          'cost': '',
          'radius_sessions_limit': '',
          'scheme_id': 0
        },
        'service_data': {
          'comment': '',
          'parent_id': 0,
          'is_dynamic': 0,
          'link_by_default': 0,
          'service_name': '',
          'tariff_id': 0,
          'contract_type': 0
        },
        'telephony_service_data': {
          'cost_info': {
            'cost_table': [],
            'discount_free_time': true,
            'first_period_length': '',
            'first_period_step': '',
            'free_time': '',
            'min_charge': '',
            'second_period_step': 1,
            'supplier_id': 0,
            'time_unit_size': 60
          }
        }
      }
    }
  },
  methods: {
    async saveTelephonyService () {
      if (!this.serviceName || !(this.serviseCost >= 0)) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Full name or cost fields is invalid'), 'Error')
        return
      }
      if (!this.costTable.length) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Price editor table is empty'), 'Error')
        return
      }

      let response
      if (this.isTemplates || this.isTariffs || this.isTariffPlan) {
        if (this.telephonyServices.service_data.parent_id === 0) this.telephonyServices.service_data.parent_id = -1
        this.linkByDefault ? this.telephonyServices.service_data.link_by_default = 1 : this.telephonyServices.service_data.link_by_default = 0
      }
      if (this.isTariffPlan) {
        this.telephonyServices.service_data.tariff_id = this.currentRowTariffPlans.id
      }
      if (this.isEdit) {
        this.telephonyServices.service_data.tariff_id = this.editTelephonyServices.service_data.tariff_id
      }
      this.telephonyServices.service_data.service_name = this.serviceName
      this.telephonyServices.periodic_service_data.cost = Number(this.serviseCost)
      this.telephonyServices.telephony_service_data.cost_info.min_charge = Number(this.telephonyServices.telephony_service_data.cost_info.min_charge)
      this.telephonyServices.telephony_service_data.cost_info.free_time = Number(this.telephonyServices.telephony_service_data.cost_info.free_time)
      this.telephonyServices.telephony_service_data.cost_info.first_period_length = Number(this.telephonyServices.telephony_service_data.cost_info.first_period_length)
      this.telephonyServices.telephony_service_data.cost_info.first_period_step = Number(this.telephonyServices.telephony_service_data.cost_info.first_period_step)
      this.telephonyServices.telephony_service_data.cost_info.second_period_step = Number(this.telephonyServices.telephony_service_data.cost_info.second_period_step)
      this.telephonyServices.telephony_service_data.cost_info.time_unit_size = Number(this.telephonyServices.telephony_service_data.cost_info.time_unit_size)
      this.telephonyServices.periodic_service_data.radius_sessions_limit = Number(this.telephonyServices.periodic_service_data.radius_sessions_limit)
      this.telephonyServices.periodic_service_data.charge_method = this.selectChargeMethod
      this.telephonyServices.service_data.contract_type = this.selectContract
      this.telephonyServices.periodic_service_data.scheme_id = this.selectScheme
      let newCost = {
        'tariff_key': 0,
        'cost_info': {
          'borders': [],
          'costs': [],
          'fixed_cost': 0,
          'prepaid': 0
        }
      }
      for (let i in this.costTable) {
        newCost.tariff_key = this.costTable[i].tariff_key
        newCost.cost_info.costs = this.costTable[i].cost_info
        this.telephonyServices.telephony_service_data.cost_info.cost_table.push(JSON.parse(JSON.stringify(newCost)))
      }
      for (let curCost of this.telephonyServices.telephony_service_data.cost_info.cost_table) {
        for (let curFixed of this.fixedRoll) {
          if (curFixed.tariff_key === curCost.tariff_key) {
            curCost.cost_info.fixed_cost = Number(curFixed.cost_info.fixed_cost)
          }
        }
      }
      for (let curCost of this.telephonyServices.telephony_service_data.cost_info.cost_table) {
        for (let curPrepaid of this.prepaidRoll) {
          if (curPrepaid.tariff_key === curCost.tariff_key) {
            curCost.cost_info.prepaid = Number(curPrepaid.cost_info.prepaid)
          }
        }
      }

      for (let curCost of this.telephonyServices.telephony_service_data.cost_info.cost_table) {
        for (let curBorder of this.borderRoll) {
          if (curBorder.tariff_key === curCost.tariff_key) {
            let newBorder = {
              'border': 0,
              'cost_coefficient': 0
            }
            newBorder.border = Number(curBorder.border)
            newBorder.cost_coefficient = Number(curBorder.cost_coefficient)
            curCost.cost_info.borders.push(newBorder)
          }
        }
      }
      for (let curTable of this.telephonyServices.telephony_service_data.cost_info.cost_table) {
        for (let curCost of curTable.cost_info.costs) {
          curCost.cost = Number(curCost.cost)
        }
      }
      if (this.isEdit) {
        this.telephonyServices.service_data.service_id = this.editTelephonyServices.service_data.service_id
        axiosInstance.put(this.$store.getters.API_TARIFFING_SERVICES_TELEPHONY, this.telephonyServices).then(response => {
          if (response.data.error) {
            this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
          } else {
            this.$root.$emit('makeToasts')
            this.$emit('hideModalServices')
            this.$emit('reload')
            setTimeout(this.$store.dispatch, 500, 'Tariffing/GET_SERVICES')
          }
        })
      } else {
        response = await axiosInstance.post(this.$store.getters.API_TARIFFING_SERVICES_TELEPHONY, this.telephonyServices).then(response => {
          if (response.data.error) {
            this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
          } else {
            this.$root.$emit('makeToasts')
            this.$emit('hideModalServices')
            this.$emit('reload')
            setTimeout(this.$store.dispatch, 500, 'Tariffing/GET_SERVICES')
            return response.data.service_id
          }
        })
      }
      let suppId = {
        'service_id': 0,
        'invoice_sup_id': 0
      }
      if (this.isEdit) {
        suppId.service_id = this.editTelephonyServices.service_data.service_id
      } else {
        suppId.service_id = response
      }
      suppId.invoice_sup_id = this.selectSupplier
      axiosInstance.put(this.$store.getters.API_TARIFFING_SERVICES_SET_SUPPLIER_ID, suppId)
      let policyId = {
        'service_id': 0,
        'policy_id': 0
      }
      if (this.isEdit) {
        policyId.service_id = this.editTelephonyServices.service_data.service_id
      } else {
        policyId.service_id = response
      }
      policyId.policy_id = this.selectPolicy
      axiosInstance.put(this.$store.getters.API_TARIFFING_SERVICES_SET_CHRGE_POLICY, policyId)
      if ((this.isTemplates && this.multipleLinking) || (this.isTariffPlan && this.multipleLinking)) {
        let multiLink = {
          'service_id': 0,
          'multiple_linking': 0
        }
        if (this.isEdit) {
          multiLink.service_id = this.editTelephonyServices.service_data.service_id
        } else {
          multiLink.service_id = response
        }
        multiLink.multiple_linking = 1
        axiosInstance.put(this.$store.getters.API_TARIFFING_SERVICES_SET_MULTI_LINKING, multiLink)
      }
      this.radiusAttr.attrs = this.radiusAttrItems
      if (this.isEdit) {
        this.radiusAttr.set_object_id = this.currentRowService.service_id
      } else {
        this.radiusAttr.set_object_id = response
      }
      axiosInstance.put(this.$store.getters.API_TARIFFING_RADIUS_ATTRS, this.radiusAttr)
    },
    async load () {
      this.telDirectionsItems = await axiosInstance.put(this.$store.getters.API_TARIFFING_GET_TEL_DIRECTIONS, this.requestTelDir).then(response => { return response.data })
      this.telZonesItems = await axiosInstance.get(this.$store.getters.API_TARIFFING_TEL_ZONES).then(response => { return response.data })
      this.timeRangeList = await axiosInstance.get(this.$store.getters.API_TARIFFING_TIME_RANGE).then(response => { return response.data })
      for (let i in this.telDirectionsItems) {
        this.telDirectionsItems[i].create_date = moment(Number(this.telDirectionsItems[i].create_date) * 1000).format('YYYY-MM-DD hh:mm')
        this.telDirectionsItems[i].update_date = moment(Number(this.telDirectionsItems[i].update_date) * 1000).format('YYYY-MM-DD hh:mm')
        for (let j in this.telZonesItems) {
          if (this.telDirectionsItems[i].zone_id === this.telZonesItems[j].zone_id) {
            this.telDirectionsItems[i].zones = this.telZonesItems[j].name + ' (' + this.telZonesItems[j].zone_id + ')'
            break
          }
        }
      }
      for (let i in this.telZonesItems) {
        this.telZonesItems[i].create_date = moment(Number(this.telZonesItems[i].create_date) * 1000).format('YYYY-MM-DD hh:mm')
        if (this.telZonesItems[i].update_date !== 0) {
          this.telZonesItems[i].update_date = moment(Number(this.telZonesItems[i].update_date) * 1000).format('YYYY-MM-DD hh:mm')
        }
      }
      for (let i in this.timeRangeList) {
        this.timeRangeList[i].range = ''
        for (let j in this.timeRangeList[i].slices) {
          this.timeRangeList[i].range += this.timeRangeList[i].slices[j].start_wday +
          ' - ' + this.timeRangeList[i].slices[j].end_wday + ' ' + this.timeRangeList[i].slices[j].start_hour +
          ':' + this.timeRangeList[i].slices[j].start_min + ':' + this.timeRangeList[i].slices[j].start_sec +
          ' - ' + this.timeRangeList[i].slices[j].end_hour + ':' + this.timeRangeList[i].slices[j].end_min +
          ':' + this.timeRangeList[i].slices[j].end_sec + '; '
        }
      }
      let contractList = await axiosInstance.get(this.$store.getters.API_TARIFFING_CONTRACT_TYPES).then(response => { return response.data })
      let suppliertList = await axiosInstance.get(this.$store.getters.API_TARIFFING_SUPPLIER).then(response => { return response.data })
      let policyList = await axiosInstance.get(this.$store.getters.API_TARIFFING_CHARGE_POLICE).then(response => { return response.data })
      let schemeList = await axiosInstance.get(this.$store.getters.API_TARIFFING_COEFFICIENT_SCHEME).then(response => { return response.data })
      for (let i in suppliertList) {
        suppliertList[i].value = suppliertList[i].id
        suppliertList[i].text = suppliertList[i].name
      }
      this.suppliertList = suppliertList
      for (let i in contractList) {
        contractList[i].value = contractList[i].id
        contractList[i].text = contractList[i].name
      }
      this.contractList = contractList
      for (let i in policyList) {
        policyList[i].value = policyList[i].policy_id
        policyList[i].text = policyList[i].name + ' (' + policyList[i].policy_id + ')'
      }
      this.policyList = policyList
      this.selectPolicy = this.policyList.length ? this.policyList[0].policy_id : null
      for (let i in schemeList) {
        schemeList[i].value = schemeList[i].id
        schemeList[i].text = schemeList[i].name
      }
      this.schemeList = schemeList
      if (this.isEdit || this.isTariffPlan) {
        this.editTelephonyServices = await axiosInstance.get(this.$store.getters.API_TARIFFING_SERVICES_TELEPHONY + '?service_id=' + this.currentRowService.service_id).then(response => { return response.data })
        this.radiusAttrItems = await axiosInstance.get(this.$store.getters.API_TARIFFING_RADIUS_ATTRS + '?object_id=' + this.editTelephonyServices.service_data.service_id + '&object_type=' + this.editTelephonyServices.service_data.service_type).then(response => { return response.data })
        for (let i in this.radiusAttrItems) {
          this.radiusAttrItems[i].value = this.radiusAttrItems[i].attr_value
          if (this.radiusAttrItems[i].tag) this.radiusAttrItems[i].value = ':' + this.radiusAttrItems[i].tag + ':' + this.radiusAttrItems[i].attr_value
          switch (this.radiusAttrItems[i].attr_type) {
            case 1:
              this.radiusAttrItems[i].attrType = this.$i18n.t('Number')
              break
            case 2:
              this.radiusAttrItems[i].attrType = this.$i18n.t('String')
              break
            case 3:
              this.radiusAttrItems[i].attrType = 'IP'
              break
            case 4:
              this.radiusAttrItems[i].attrType = this.$i18n.t('Binary')
              break
          }
        }
        this.serviseCost = this.editTelephonyServices.periodic_service_data.cost
        this.serviceName = this.editTelephonyServices.service_data.service_name
        this.telephonyServices.service_data.comment = this.editTelephonyServices.service_data.comment
        this.telephonyServices.telephony_service_data.cost_info.free_time = this.editTelephonyServices.telephony_service_data.cost_info.free_time
        this.telephonyServices.telephony_service_data.cost_info.min_charge = this.editTelephonyServices.telephony_service_data.cost_info.min_charge
        this.telephonyServices.telephony_service_data.cost_info.first_period_length = this.editTelephonyServices.telephony_service_data.cost_info.first_period_length
        this.telephonyServices.telephony_service_data.cost_info.first_period_step = this.editTelephonyServices.telephony_service_data.cost_info.first_period_step
        this.telephonyServices.telephony_service_data.cost_info.second_period_step = this.editTelephonyServices.telephony_service_data.cost_info.second_period_step
        this.telephonyServices.telephony_service_data.cost_info.time_unit_size = this.editTelephonyServices.telephony_service_data.cost_info.time_unit_size
        this.telephonyServices.periodic_service_data.radius_sessions_limit = this.editTelephonyServices.periodic_service_data.radius_sessions_limit
        this.telephonyServices.telephony_service_data.cost_info.discount_free_time = this.editTelephonyServices.telephony_service_data.cost_info.discount_free_time
        this.selectSupplier = this.editTelephonyServices.service_data.invoice_sup_id
        this.selectContract = this.editTelephonyServices.service_data.contract_type
        this.selectPolicy = this.editTelephonyServices.periodic_service_data.policy_id
        this.selectScheme = this.editTelephonyServices.periodic_service_data.scheme_id
        this.selectChargeMethod = this.editTelephonyServices.periodic_service_data.charge_method

        this.costTable = JSON.parse(JSON.stringify(this.editTelephonyServices.telephony_service_data.cost_info.cost_table))
        for (let i in this.costTable) {
          if (this.costTable[i].tariff_key >= 1000000) {
            for (let j in this.telDirectionsItems) {
              if (this.costTable[i].tariff_key === this.telDirectionsItems[j].dir_id) {
                this.costTable[i].nameTel = this.telDirectionsItems[j].name
              }
            }
          } else {
            for (let j in this.telZonesItems) {
              if (this.costTable[i].tariff_key === this.telZonesItems[j].zone_id) {
                this.costTable[i].nameTel = this.telZonesItems[j].name
              }
            }
          }
        }
        this.costTimeRange = JSON.parse(JSON.stringify(this.costTable[0].cost_info.costs))
        for (let i in this.costTimeRange) {
          for (let j in this.timeRangeList) {
            if (this.costTimeRange[i].time_range_id === this.timeRangeList[j].tr_id) {
              this.costTimeRange[i].nameTimeRange = this.timeRangeList[j].name
            }
          }
        }
        let arr = JSON.parse(JSON.stringify(this.costTable))
        for (let i in arr) {
          if (arr[i].cost_info.fixed_cost) {
            this.fixedRoll.push(arr[i])
          }
          if (arr[i].cost_info.prepaid) {
            this.prepaidRoll.push(arr[i])
          }
        }
        for (let i in arr) {
          for (let j in arr[i].cost_info.borders) {
            arr[i].cost_info.borders[j].nameTel = JSON.parse(JSON.stringify(arr[i].nameTel))
            arr[i].cost_info.borders[j].tariff_key = JSON.parse(JSON.stringify(arr[i].tariff_key))
            this.borderRoll.push(arr[i].cost_info.borders[j])
          }
        }
        for (let i in this.costTable) {
          this.costTable[i].cost_info = this.costTable[i].cost_info.costs
        }
        if (this.isTemplates || this.isTariffs || this.isTariffPlan) {
          this.telephonyServices.service_data.parent_id = this.editTelephonyServices.service_data.parent_id
          if (this.editTelephonyServices.service_data.link_by_default === 1) {
            this.linkByDefault = true
          } else {
            this.linkByDefault = false
          }
          if (this.editTelephonyServices.service_data.multiple_linking === 1) {
            this.multipleLinking = true
          } else {
            this.multipleLinking = false
          }
        }
      }
    },
    swohAddRadiusAttr () {
      this.rowRadiusAttr = null
      this.isEditRadiusAttr = false
      this.$refs.modalRadiusAttr.show()
    },
    ClickOnEditRadiusAttrButton (row) {
      this.rowRadiusAttr = row.item
      this.isEditRadiusAttr = true
      this.$refs.modalRadiusAttr.show()
    },
    hideAddRadiusAttr () {
      this.$refs.modalRadiusAttr.hide()
    },
    deleteRadiusAttr (row) {
      this.rowRadiusAttr = row.item
      this.radiusAttrItems = this.radiusAttrItems.filter((value) => {
        return value !== this.rowRadiusAttr
      })
    },
    showAddTimeRange () {
      this.rowTimeRange = null
      this.$refs.modalTimeRange.show()
    },
    hideAddTimeRange () {
      this.$refs.modalTimeRange.hide()
    },
    rowClickTimeRange (row) {
      this.rowTimeRange = row
    },
    addTimeRange () {
      if (!this.rowTimeRange) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Select time range'), 'Error')
        return
      }
      for (let i in this.costTimeRange) {
        if (this.costTimeRange[i].time_range_id === this.rowTimeRange.tr_id) {
          this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Attempt to add one more time range for same id'), 'Error')
          return
        }
      }
      this.rowTimeRange.cost = 0
      this.rowTimeRange.nameTimeRange = this.rowTimeRange.name
      this.rowTimeRange.time_range_id = this.rowTimeRange.tr_id
      this.costTimeRange.push(JSON.parse(JSON.stringify(this.rowTimeRange)))
      for (let curCostTable of this.costTable) {
        curCostTable.cost_info.push(JSON.parse(JSON.stringify(this.rowTimeRange)))
      }

      this.hideAddTimeRange()
    },
    showAddTelDirections () {
      this.rowTelDirections = null
      this.isBorder = false
      this.isFixed = false
      this.isPrepaid = false
      this.$refs.modalTelDirections.show()
    },
    showAddTelDirBorder () {
      this.isBorder = true
      this.isFixed = false
      this.isPrepaid = false
      this.rowTelDirections = null
      this.$refs.modalTelDirections.show()
    },
    showAddTelDirPrepaid () {
      this.isBorder = false
      this.isFixed = false
      this.isPrepaid = true
      this.rowTelDirections = null
      this.$refs.modalTelDirections.show()
    },
    showAddTelDirFixed () {
      this.isBorder = false
      this.isFixed = true
      this.isPrepaid = false
      this.rowTelDirections = null
      this.$refs.modalTelDirections.show()
    },
    hideAddTelDirections () {
      this.$refs.modalTelDirections.hide()
    },
    rowClickTelDirections (row) {
      this.rowTelDirections = row
    },
    addTelDirections () {
      if (!this.rowTelDirections) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Select telephone direction'), 'Error')
        return
      }
      if (this.isBorder || this.isPrepaid || this.isFixed) {
        let isBoolean = this.costTable.find(el => {
          return el.tariff_key === this.rowTelDirections.dir_id
        })
        if (isBoolean) {
          if (this.isBorder) {
            let newBorder = {
              'nameTel': '',
              'tariff_key': 0,
              'border': 0,
              'cost_coefficient': 1
            }
            newBorder.nameTel = this.rowTelDirections.name
            newBorder.tariff_key = this.rowTelDirections.dir_id
            this.borderRoll.push(newBorder)
          }
          if (this.isPrepaid) {
            for (let i in this.prepaidRoll) {
              if (this.prepaidRoll[i].tariff_key === this.rowTelDirections.dir_id) {
                this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Attempt to add one more telephone direction for same id'), 'Error')
                return
              }
            }
            let newPrepaid = {
              'nameTel': '',
              'tariff_key': 0,
              'cost_info': {
                'prepaid': 0
              }
            }
            newPrepaid.nameTel = this.rowTelDirections.name
            newPrepaid.tariff_key = this.rowTelDirections.dir_id
            this.prepaidRoll.push(newPrepaid)
          }
          if (this.isFixed) {
            for (let i in this.fixedRoll) {
              if (this.fixedRoll[i].tariff_key === this.rowTelDirections.dir_id) {
                this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Attempt to add one more telephone direction for same id'), 'Error')
                return
              }
            }
            let newFixed = {
              'nameTel': '',
              'tariff_key': 0,
              'cost_info': {
                'fixed_cost': 0
              }
            }
            newFixed.nameTel = this.rowTelDirections.name
            newFixed.tariff_key = this.rowTelDirections.dir_id
            this.fixedRoll.push(newFixed)
          }
        } else {
          this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Not in the table price'), 'Error')
          return
        }
      } else {
        for (let i in this.costTable) {
          if (this.costTable[i].tariff_key === this.rowTelDirections.dir_id) {
            this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Attempt to add one more telephone direction for same id'), 'Error')
            return
          }
        }
        let newCostTable = {
          'tariff_key': 0,
          'nameTel': '',
          'cost_info': []
        }
        newCostTable.nameTel = this.rowTelDirections.name
        newCostTable.tariff_key = this.rowTelDirections.dir_id
        newCostTable.cost_info = JSON.parse(JSON.stringify(this.costTimeRange))
        this.costTable.push(newCostTable)
      }
      this.hideAddTelDirections()
    },
    showAddTelZones () {
      this.isBorder = false
      this.isFixed = false
      this.isPrepaid = false
      this.rowTelZones = null
      this.$refs.modalTelZones.show()
    },
    showAddTelZonesBorder () {
      this.isBorder = true
      this.isFixed = false
      this.isPrepaid = false
      this.rowTelZones = null
      this.$refs.modalTelZones.show()
    },
    showAddTelZonesPrepaid () {
      this.isBorder = false
      this.isFixed = false
      this.isPrepaid = true
      this.rowTelZones = null
      this.$refs.modalTelZones.show()
    },
    showAddTelZonesFixed () {
      this.isBorder = false
      this.isFixed = true
      this.isPrepaid = false
      this.rowTelZones = null
      this.$refs.modalTelZones.show()
    },
    hideAddTelZones () {
      this.$refs.modalTelZones.hide()
    },
    rowClickTelZones (row) {
      this.rowTelZones = row
    },
    addTelZones () {
      if (!this.rowTelZones) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Select telephone zone'), 'Error')
        return
      }
      if (this.isBorder || this.isPrepaid || this.isFixed) {
        let isBoolean = this.costTable.find(el => {
          return el.tariff_key === this.rowTelZones.zone_id
        })
        if (isBoolean) {
          if (this.isBorder) {
            let newBorder = {
              'nameTel': '',
              'tariff_key': 0,
              'border': 0,
              'cost_coefficient': 1
            }
            newBorder.nameTel = this.rowTelZones.name
            newBorder.tariff_key = this.rowTelZones.zone_id
            this.borderRoll.push(newBorder)
          }
          if (this.isPrepaid) {
            for (let i in this.prepaidRoll) {
              if (this.prepaidRoll[i].tariff_key === this.rowTelZones.zone_id) {
                this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Attempt to add one more telephone direction for same id'), 'Error')
                return
              }
            }
            let newPrepaid = {
              'nameTel': '',
              'tariff_key': 0,
              'cost_info': {
                'prepaid': 0
              }
            }
            newPrepaid.nameTel = this.rowTelZones.name
            newPrepaid.tariff_key = this.rowTelZones.zone_id
            this.prepaidRoll.push(newPrepaid)
          }
          if (this.isFixed) {
            for (let i in this.fixedRoll) {
              if (this.fixedRoll[i].tariff_key === this.rowTelZones.zone_id) {
                this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Attempt to add one more telephone direction for same id'), 'Error')
                return
              }
            }
            let newFixed = {
              'nameTel': '',
              'tariff_key': 0,
              'cost_info': {
                'fixed_cost': 0
              }
            }
            newFixed.nameTel = this.rowTelZones.name
            newFixed.tariff_key = this.rowTelZones.zone_id
            this.fixedRoll.push(newFixed)
          }
        } else {
          this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Not in the table price'), 'Error')
          return
        }
      } else {
        for (let i in this.costTable) {
          if (this.costTable[i].tariff_key === this.rowTelZones.zone_id) {
            this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Attempt to add one more telephone direction for same id'), 'Error')
            return
          }
        }
        let newCostTable = {
          'tariff_key': 0,
          'nameTel': '',
          'cost_info': []
        }
        newCostTable.nameTel = this.rowTelZones.name
        newCostTable.tariff_key = this.rowTelZones.zone_id
        newCostTable.cost_info = JSON.parse(JSON.stringify(this.costTimeRange))
        this.costTable.push(newCostTable)
      }
      this.hideAddTelZones()
    },
    hideModalServices () {
      this.$emit('hideModalServices')
    },
    deleteTimeRange (item) {
      this.costTimeRange = this.costTimeRange.filter((value) => {
        return value.time_range_id !== item.time_range_id
      })
      for (let curTable of this.costTable) {
        curTable.cost_info = curTable.cost_info.filter((value) => {
          return value.time_range_id !== item.time_range_id
        })
      }
    },
    deleteCost (item) {
      this.costTable = this.costTable.filter((value) => {
        return value.tariff_key !== item.tariff_key
      })
    },
    deleteBorder (item) {
      this.borderRoll = this.borderRoll.filter((value) => {
        return value.tariff_key !== item.tariff_key
      })
    },
    deletePrepaid (item) {
      this.prepaidRoll = this.prepaidRoll.filter((value) => {
        return value.tariff_key !== item.tariff_key
      })
    },
    deleteFixed (item) {
      this.fixedRoll = this.fixedRoll.filter((value) => {
        return value.tariff_key !== item.tariff_key
      })
    }
  },
  mounted () {
    this.load()
  },
  watch: {
    serviceName: function (val) {
      if (val.length) {
        this.validationName = true
      } else {
        this.validationName = false
      }
    },
    serviseCost: function (val) {
      if (val >= 0) {
        this.validationCost = true
      } else {
        this.validationCost = false
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/tariffication/servicesAndTariffs/formTelephonyService.vue